<div>
    <mat-dialog-content>
        <mat-icon  class="red-400-fg" svgIcon="close-circle"></mat-icon>
        <h3 class="title" *ngIf="data.title">{{ data.title }}</h3>
        <p class="text" *ngIf="data.text">{{ data.text }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <button mat-raised-button color="primary" class="btn-w-md" (click)="dialogRef.close(true)">{{'aceptar'}}</button>
    </mat-dialog-actions>
</div>